// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"CK3djfG8hpPAkQK0UnOVp"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import React from 'react';
import * as Sentry from '@sentry/nextjs';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: true,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  sampleRate: 0.1,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  beforeBreadcrumb: (breadcrumb) => {
    // Filter out HTTP requests to analytics providers
    const excludedHosts = ['posthog.com'];
    if (breadcrumb.type === 'http' && breadcrumb.data?.url) {
      try {
        const url = new URL(`${breadcrumb.data.url}`);
        if (excludedHosts.includes(url.hostname)) {
          // Don't send the breadcrumb
          return null;
        }
      } catch (e) {
        // If there's some problem with our understanding of the url, just return the breadcrumb
        return breadcrumb;
      }
    }
    return breadcrumb;
  },

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      buttonLabel: 'Give Us Feedback!',
      formTitle: 'Give Us Feedback!',
      submitButtonLabel: 'Send Feedback',
      messagePlaceholder: 'So, what do you think?',
    }),
    Sentry.rewriteFramesIntegration({
      root: '/next',
    }),
  ],
});
